<div class="modal-header">
  <h5 class="modal-title pull-left">
    <font color="#0063b9">
      <i class="fas fa-store me-1" style="color: #00549d"></i> Retiro en Tienda
    </font>
  </h5>
  <button type="button" class="btn" (click)="modalRef.hide()">
    <i class="fas fa-times-circle" style="color: #00549d; font-size: 18px"></i>
  </button>
</div>
<div class="modal-body">
  <app-filtro-magico
    [filtros]="magicFilters"
    [closeOnSelect]="true"
    (onFiltrosCambiados)="onSelectStore($event)"
  >
  </app-filtro-magico>
  <hr />

  @if (availabilities.length && currentSelectedStore) {
  <div class="col-sm-12" style="margin-bottom: 10px">
    @if (!isLoading) {
    <app-mapa-fichas
      [selectedStore]="currentSelectedStore"
      [stock]="maxStock"
      [productDropshipment]="productDropshipment"
    />
    }
  </div>
  } @if (!availabilities.length && !isLoading) {
  <div class="dia-container-habilitado">
    <div style="font-size: 14px; color: #00549d">
      <i class="fas fa-info-circle fa-lg me-1"></i> Retiro a Tienda no
      disponible
    </div>
  </div>
  } @if (isLoading) {
  <div class="dia-container-habilitado">
    <div style="font-size: 14px; color: #00549d">
      <i class="fas fa-info-circle fa-lg me-1"></i> Cargando Información
    </div>
  </div>
  } @if (!isLoading) {
  <app-fechas-promesas [promesas]="availabilities"></app-fechas-promesas>
  } @if (!isLoading) {
  <div
    style="margin-top: 10px; background-color: #efefef"
    class="alert alert-secondary"
    role="alert"
  >
    @if (currentSelectedStore) {
    <strong>{{ currentSelectedStore.schedule }}</strong>
    }
  </div>
  }
</div>
<div class="modal-footer justify-content-start">
  <div class="row">
    <div class="col-sm-12" style="font-size: 14px; margin-bottom: 10px">
      <i class="fas fa-info-circle fa-lg me-1" style="color: #00549d"></i> La
      información de disponibilidad puede variar durante la compra.
    </div>
  </div>
</div>
